import {Component} from 'preact';
import MapPauseButton from './MapPauseButton';
import MapPlayButton from './MapPlayButton';

export default class MapControls extends Component {
    render() {
        const {togglePause} = this.props;
        return (
            <div className={'map-controls'}>
                <MapPauseButton togglePause={togglePause}/>
                <MapPlayButton togglePause={togglePause}/>
            </div>
        );
    }
}